<div *ngLet="langChange$ | async" class="tab-container mt40">
  <div [routerLink]="dataLink" [class.active]="isActiveDataUrl" class="custom-tab">
    {{ 'LAYOUT.DATA' | translate }}
  </div>
  <div *ngIf="isRuLocale" [routerLink]="appLink" [class.active]="isActiveAppsUrl" class="custom-tab">
    {{ 'OTHER.APPS' | translate }}
  </div>
  <div *ngIf="isRuLocale"  [routerLink]="newsLink" [class.active]="isActiveNewsUrl" class="custom-tab">
    {{ 'VERSION_VISUALLY_IMPAIRED.NEWS' | translate }}
  </div>
  <div [routerLink]="informationLink" [class.active]="isActiveInformationUrl" class="custom-tab">
    {{ 'VERSION_VISUALLY_IMPAIRED.INFORMATION' | translate }}
  </div>
</div>
<div class="tab-data-container mt24">
  <router-outlet></router-outlet>
</div>
